const PERMISSION_KEY= "core:user_authority_mapping";
const PAGE_URL = {
    USER_AUTHORITY_MAPPING_PAGE: "/admin/core/user-authority-mapping"
}

export {PERMISSION_KEY, PAGE_URL}

